module.exports = __webpack_public_path__ + "054a7c6c1f73e45a7c635aeffde05131.jpg";